<template>
  <div>
    <div v-if="replies.length > 0">
      <div class="replyOrderOptions">
        <el-switch
          v-model="reverse"
          active-text="最新回复在最底端"
          inactive-text="最新回复在最顶端"
        >
        </el-switch>
      </div>
      <el-pagination
        :current-page.sync="currentPage"
        layout="total, prev, pager, next, jumper"
        :total="this.total"
        :page-size="this.size"
        :hide-on-single-page="true"
      >
      </el-pagination>
      <el-timeline>
        <el-timeline-item
          v-for="reply in replies"
          :key="reply.id"
          :id="'#' + reply.id"
          :type="
            isLoggedIn && reply.user.id === user.id ? 'primary' : 'default'
          "
          :timestamp="reply.created_at | moment('from')"
          placement="top"
          style="cursor:pointer"
        >
          <el-card
            class="replyBox"
            :title="
              reply.created_at
                | moment(
                  'timezone',
                  reply.created_at.timezone,
                  'MM-DD HH:mm:ss z'
                )
            "
          >
            <div v-html="reply.content" style="white-space:pre"></div>
            <div class="text-right secondary-font">
              <div>
                <router-link :to="'/users/' + reply.user.id" class="float-left">
                  {{ reply.user.name }}
                </router-link>

                <span v-if="isLoggedIn && (admin || reply.user.id === user.id)">
                  <a href="#" @click.prevent="deleteReply(reply.id)"> 🗑 删除</a>
                </span>
                <span v-else>
                  <router-link
                    :to="{ path: '/messages', query: { id: reply.user.id } }"
                  >
                    ✉️ 私信
                  </router-link>
                  <span>
                    ⋅
                    <a href="#" @click.prevent="showReportReplySpam(reply.id)">
                      🚫 举报
                    </a>
                  </span>
                </span>
              </div>
            </div>
          </el-card>
        </el-timeline-item>
      </el-timeline>
      <el-pagination
        :current-page.sync="currentPage"
        layout="total, prev, pager, next, jumper"
        :total="this.total"
        :page-size="this.size"
        :hide-on-single-page="true"
      >
      </el-pagination>
    </div>
    <div v-else>
      <p class="text-center">目前还没有回复</p>
    </div>
    <!--modal for reply spam-->
    <b-modal
      id="reportReplySpam"
      centered
      scrollable
      title="举报回复"
      size="md"
      hide-footer
    >
      <SpamReportComponent
        :topic-id="id"
        :reply-id="replyId"
        @close="closeReportSpam"
      ></SpamReportComponent>
    </b-modal>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
import SpamReportComponent from "../components/SpamReportComponent";
import $ from "jquery";

export default {
  props: ["id", "admin"],
  data() {
    return {
      replies: [],
      replyId: "",
      // pagination related
      total: 1,
      size: 10,
      currentPage: 1,
      totalPages: 1,
      reverse: true
    };
  },
  computed: {
    ...mapGetters(["isLoggedIn"]),
    ...mapState(["user"])
  },
  created: function() {
    this.fetchReplies();
  },
  // pagination related
  watch: {
    "user.settings": function() {
      localStorage.setItem("replyReverse", this.reverse);
      this.fetchReplies();
    },
    currentPage: function() {
      this.fetchReplies();
    },
    reverse: function(newVal) {
      // if (!this.isLoggedIn) {
      // this.reverse = localStorage.getItem("replyReverse") !== "false";
      localStorage.setItem("replyReverse", newVal);
      this.fetchReplies();
      // } else {
      //   var parsedSettings = JSON.parse(this.user.settings);
      //   var settingData = {
      //     settings: JSON.stringify(parsedSettings)
      //   };
      //   parsedSettings.replyReverse = newVal;
      //   this.setLoading(true);
      //   var self = this;
      //   this.updateUserInfo(settingData)
      //       .then(() => {
      //         this.$message({
      //           message: "用户设置已更新",
      //           type: "success",
      //           duration: 2000
      //         });
      //         self.setLoading(false);
      //       })
      //       .catch(err => {
      //         if (err.response.status != 422) {
      //           this.$message({
      //             message: ":( 更新未成功，请稍后重试",
      //             type: "error",
      //             duration: 3000
      //           });
      //         }
      //         self.setLoading(false);
      //       });
      // }
    }
  },
  methods: {
    ...mapActions(["updateUserInfo"]),
    ...mapMutations(["setLoading", "setShowLoginModalSwitch"]),

    setInitialOrdering: function() {
      if (!this.isLoggedIn) {
        this.reverse = localStorage.getItem("replyReverse") !== "false";
      } else {
        try {
          var parsedSettings = JSON.parse(this.user.settings);
          this.reverse = parsedSettings.replyReverse;
        } catch (e) {
          console.log(e);
        }
      }
    },
    closeReportSpam: function() {
      this.$bvModal.hide("reportReplySpam");
    },
    showReportReplySpam(replyId) {
      if (!this.isLoggedIn) {
        this.setShowLoginModalSwitch(true);
      }
      this.replyId = replyId;
      this.$bvModal.show("reportReplySpam");
    },
    fetchReplies() {
      let hash = window.location.hash;
      if (this.size === 0 || this.currentPage > this.totalPages) {
        return;
      }

      this.$axios
        .get(
          `/topics/${this.id}/replies?r=${this.reverse}&page=${this.currentPage}`
        )
        .then(res => {
          this.replies = res.data.data;
          this.total = res.data.meta.pagination.total;
          this.size = res.data.meta.pagination.per_page;
          this.totalPages = res.data.meta.pagination.total_pages;

          setTimeout(() => {
            if (hash) {
              let el = document.getElementById(hash);
              if (el == null) {
                this.currentPage++;
                return;
              }
              el.scrollIntoView();
              var bgOpacity = 1.0;
              var bgfade = function() {
                bgOpacity -= 0.02;
                el.style.backgroundColor =
                  "rgba(255, 242, 130, " + bgOpacity + ")";
                if (bgOpacity >= 0) {
                  setTimeout(bgfade, 100);
                }
              };
              bgfade();
            }
          }, 500);
          setTimeout(() => {
            this.collapseReplies();
          }, 1000);
        });
    },
    deleteReply: function(replyId) {
      var wording = "确定永久删除该回复?";
      if (this.admin) {
        wording += " 如果改回复有被举报，举报信息也将被一起删除！";
      }
      this.$confirm(wording, "删除", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.setLoading(true);
        var self = this;
        this.$http
          .delete("/topics/" + this.id + "/replies/" + replyId)
          .then(() => {
            this.$message({
              showClose: true,
              type: "success",
              message: "删除成功"
            });
            self.setLoading(false);
            this.$emit("topicDeleted");
            this.fetchReplies();
          })
          .catch(() => {
            this.$message({
              showClose: true,
              type: "error",
              message: "删除不成功，请稍后再试"
            });
            self.setLoading(false);
          });
      });
    },

    collapseReplies: function() {
      // const elements = document.getElementsByClassName(
      //     "el-timeline-item__timestamp"
      // );
      const elements = document.querySelectorAll(
        ".el-timeline-item__timestamp:not(.bound)"
      );
      var count = 0;
      for (const el of elements) {
        var toggleSymbol = document.createElement("p");
        var symbolText = document.createTextNode("−");
        let toggleId = "toggleId" + count;
        toggleSymbol.id = toggleId;
        toggleSymbol.style.marginTop = "14px";
        toggleSymbol.style.color = "var(--color-fg-subtle)";
        toggleSymbol.appendChild(symbolText);
        el.parentElement.previousElementSibling.appendChild(toggleSymbol);

        el.parentElement.addEventListener("click", function() {
          toggleReply(toggleId, el);
        });
        // el.addEventListener("click", function() {
        //   toggleReply(toggleId, el);
        // });
        $(el).addClass("bound");
        el.addEventListener("mouseover", function() {
          el.style.color = "#00c851";
        });
        el.addEventListener("mouseleave", function() {
          el.style.color = "rgb(144, 147, 153)";
        });
        count++;
      }

      function toggleReply(toggleId, el) {
        let toggleSelector = "#" + toggleId;
        if ($(toggleSelector).text() == "+") {
          $(toggleSelector).text("−");
        } else {
          $(toggleSelector).text("+");
        }
        $(el)
          .next(".el-timeline-item__content")
          .toggle(300);
      }
    }
  },
  components: {
    SpamReportComponent
  }
};
</script>

<style scoped>
.replyBox .el-card__body {
  padding-bottom: 5px;
}

.el-timeline {
  padding-inline-start: 0;
}

.replyOrderOptions {
  text-align: right;
  margin: 20px 0;
}
</style>
